import styled from 'styled-components';

export const MainContent = styled.main`
  padding: 8px 30px 70px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);

  td {
    vertical-align: middle;
  }

  .head {
    border-bottom: 1px solid #d5ddf2;
    padding: 0 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: 20px;

    .month {
      font-style: normal;
      font-weight: 600;
      font-size: 25px;
      line-height: 130%;
      color: var(--color-text-muted);
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
    .right-side {
      text-align: right;
      .line {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 180%;
        color: var(--color-text-muted);
        white-space: nowrap;
        span {
          font-weight: 600;
        }
      }
    }
  }
`;
